function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import EventEmitter from 'events';
import TemplateManager from './TemplateManager';

var ViewManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(ViewManager, _EventEmitter);

  var _super = _createSuper(ViewManager);

  function ViewManager() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ViewManager);

    _this = _super.call(this);
    _this.views = new TemplateManager(config.urls.root);
    return _this;
  }

  _createClass(ViewManager, [{
    key: "mount",
    value: function mount(name, file) {
      var _this2 = this;

      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // console.log( location, name, file, props )
      return new Promise(function (resolve, reject) {
        if (!_this2.views.templates[name]) {
          _this2.views.add(name, file).then(function (compiler) {
            _this2.views.templates[name] = compiler;
            resolve({
              compiled: compiler(props)
            });
          }).catch(function (e) {
            reject(e);
          });
        } else {
          var compiler = _this2.views.templates[name];
          resolve({
            compiled: compiler(props)
          });
        }
      });
    }
  }, {
    key: "unmount",
    value: function unmount(name) {// let mounted = this.mounts[name]
      // if (mounted) {
      //   delete this.mounts[name]
      // }
    }
  }]);

  return ViewManager;
}(EventEmitter);

export { ViewManager as default };